import BasicInfoList from './BasicInfoList';

export default BasicInfoList;
